/* eslint-disable no-empty-label */

export const Themes = {
  navy: {
    sideBack: '#2e4356',
    sideActiveBack: '#2e4356',
    sideHoverBack: '#263445',
    sideColor: '#f4f4f5 ',
    sideActiveColor: '#409EFA',
    headerBack: '#fff',
    color: '#333',
    mainBack: '#f2f2f2',
    mainColor: '#fff',
    loginTheme: '#2e4356'
  },
  blue: {
    sideBack: '#fff',
    sideActiveBack: '#409EFA',
    sideHoverBack: '#f6f6f6',
    sideColor: '#333',
    sideActiveColor: '#409EFA',
    headerBack: '#00dda8',
    mainBack: '#fff',
    color: '#333',
    loginTheme: '#409EFA'
  }
}

/**
 * @2019/4/18
 * @author: huiming
 * desc:  用户信息的缓存信息级别，local代表永久缓存，后端不删除不会删除，
 * session表示关闭浏览器消失
 * 安全级别不是特别高的建议local 否者选session
 */
export const StorageList = {
  local: 'LOCAL',
  Session: 'SESSION'
}

export const XhrMethods = {
  get: 'GET',
  post: 'POST',
  catch: 'CATCH',
  put: 'PUT'
}

export const XhrTypes = {
  body: 'body',
  query: 'query'
}

export const XhrRespondeCode = {
  success: 0
}

export const XhrContentTypes = {
  www: 'application/x-www-form-urlencoded;charset=utf-8',
  json: 'application/json;charset=utf-8',
  form: 'multipart/form-data'
}

export const TokenInvalidCodes = [600, 601]

export const OrderOperates = {
  respond: { label: '响应', type: 'primary', key: 'respond' },
  close: { label: '关单', type: 'default', key: 'close' },
  back: { label: '返回', type: 'default', key: 'back', allPermit: true },
  dispatch: { label: '派工', type: 'primary', key: 'dispatch' },
  changeDispatch: { label: '改派', type: 'primary', key: 'changeDispatch' },
  reminder: { label: '催单', type: 'primary', key: 'reminder' },
  print: { label: '打印', type: 'default', key: 'print' },
  follow: { label: '关注', type: 'default', key: 'follow' },
  delete: { label: '删除', type: 'default', key: 'delete' },
  audit: { label: '审核', type: 'primary', key: 'audit' },
  approve: { label: '审核', type: 'primary', key: 'approve' },
  publish: { label: '发布需求', type: 'primary', key: 'publish' },
  modify: { label: '变更申请', type: 'primary', key: 'modify' },
  inspectSelf: { label: '自检验收', type: 'primary', key: 'inspectSelf' },
  inspect: { label: '验收', type: 'primary', key: 'inspect' },
  reply: { label: '回复', type: 'primary', key: 'reply' },
  estimate: { label: '评价', type: 'primary', key: 'estimate' },
  //2023-11-06新增状态
  cancel: { label: '取消', type: 'default', key: 'cancel' },
  discard: { label: '作废', type: 'primary', key: 'discard' },
  return: { label: '退回', type: 'primary', key: 'return' }
}
///**************  全局工单状态  **************/
//2023-11-6更新，将全局的工单状态全部统一
//状态配置obj
export const OrderStatus = {
  READY_REPLY: {
    label: '待回复',
    key: 'READY_REPLY',
    query: 'ready_reply',
    color: '#1915D3',
    tagBack: '#EBEBFF',
    handles: [OrderOperates.reply, OrderOperates.cancel, OrderOperates.back]
  },
  READY_DISPATCH: {
    label: '待派单',
    key: 'READY_DISPATCH',
    query: 'ready_dispatch',
    color: '#F4A126',
    tagBack: '#FFFAF0',
    handles: [OrderOperates.dispatch, OrderOperates.reminder, OrderOperates.cancel, OrderOperates.back]
  },
  READY_ACCEPT: {
    label: '待接单',
    key: 'READY_ACCEPT',
    query: 'ready_accept',
    color: '#FF8C41',
    tagBack: '#FFF4EE',
    handles: [OrderOperates.changeDispatch, OrderOperates.reminder, OrderOperates.close, OrderOperates.back]
  },
  READY_REACH: {
    label: '待到达',
    key: 'READY_REACH',
    query: 'ready_reach',
    color: '#EF55DC',
    tagBack: '#FFEEFD',
    handles: [OrderOperates.reminder, OrderOperates.close, OrderOperates.back]
  },
  READY_COMPLETE: {
    label: '待完工',
    key: 'READY_COMPLETE',
    query: 'ready_complete',
    color: '#007BFF',
    tagBack: '#ECF5FF',
    handles: [OrderOperates.reminder, OrderOperates.close, OrderOperates.back]
  },
  HANG: {
    label: '挂起中',
    key: 'HANG',
    query: 'hang',
    color: '#A800ED',
    tagBack: '#F4E4F7',
    handles: [OrderOperates.reminder, OrderOperates.close, OrderOperates.back]
  },
  READY_APPROVE: {
    label: '待审核',
    key: 'READY_APPROVE',
    query: 'ready_approve',
    color: '#00B2EC',
    tagBack: '#EBFAFF',
    handles: [OrderOperates.audit, OrderOperates.close, OrderOperates.back]
  },
  FINISH: {
    label: '已完工',
    key: 'FINISH',
    query: 'finish',
    color: '#0EACA1',
    tagBack: '#E7F5F4',
    handles: [OrderOperates.discard, OrderOperates.return, OrderOperates.back]
  },
  BACK: {
    label: '已退单',
    key: 'BACK',
    query: 'back',
    color: '#F33044',
    tagBack: '#FFECEE',
    handles: [OrderOperates.changeDispatch, OrderOperates.close, OrderOperates.back]
  },
  CLOSE: {
    label: '已关单',
    key: 'CLOSE',
    query: 'close',
    color: '#333333',
    tagBack: '#EDEDED',
    handles: [OrderOperates.back]
  },
  //2023-11-8新增状态
  CANCEL: {
    label: '已取消',
    key: 'CANCEL',
    query: 'cancel',
    color: '#333333',
    tagBack: '#EDEDED',
    handles: [OrderOperates.back]
  },
  DISCARD: {
    label: '已作废',
    key: 'DISCARD',
    query: 'discard',
    color: '#6D6D8F',
    tagBack: '#EDEDFF',
    handles: [OrderOperates.back]
  }
}
const _OrderStatus = () => {
  const _OrderStatus = { ...OrderStatus }
  delete _OrderStatus.READY_REPLY
  return _OrderStatus
}
//状态配置列表
export const OrderStatusList = Object.keys(_OrderStatus()).map((key) => _OrderStatus()[key])
//维修单状态单独配置，因为存在待回复状态
export const RepairOrderStatusList = Object.keys(OrderStatus).map((key) => OrderStatus[key])
///**************  end  **************/


///**************  工单流程全部的key配置  **************/
export const OrderEvents = {
  CREATE: { label: '创建工单', key: 'CREATE', operate: '提交申请' },
  AUDIT: { label: '审核事件', key: 'AUDIT', operate: '审核工单' },
  PUBLISH: { label: '发布', key: 'PUBLISH', operate: '发布需求' },
  BID: { label: '竞标', key: 'BID', operate: '参与竞标' },
  DISPATCH: { label: '派单', key: 'DISPATCH', operate: '派单' },
  DISTRIBUTED: { label: '派单', key: 'DISTRIBUTED', operate: '派单' },
  ACCEPT: { label: '接单', key: 'ACCEPT', operate: '确认接单' },
  REDISPATCH: { label: '改派', key: 'REDISPATCH', operate: '订单改派' },
  COMPANION_ACCEPT: { label: '接单', key: 'COMPANION_ACCEPT', operate: '确认接单' },
  CANCEL: { label: '退单', key: 'CANCEL', operate: '提交退单' },
  COMPANION_CANCEL: { label: '退单', key: 'COMPANION_CANCEL', operate: '提交退单' },
  COMMIT: { label: '提交', key: 'COMMIT', operate: '提交完成' },
  FIRST_AUDIT: { label: '初审', key: 'FIRST_AUDIT', operate: '同意验收' },
  FINAL_AUDIT: { label: '终审', key: 'FINAL_AUDIT', operate: '同意验收' },
  REPLY: { label: '回复工单', key: 'REPLY', operate: '确认回复' },
  REACH: { label: '签到', key: 'REACH', operate: '签到完成' },
  COMPANION_REACH: { label: '签到', key: 'COMPANION_REACH', operate: '签到完成' },
  HANG: { label: '挂起', key: 'HANG', operate: '申请挂起' },
  COMPANION_HANG: { label: '挂起', key: 'COMPANION_HANG', operate: '申请挂起' },
  UN_HANG: { label: '取消挂起', key: 'UN_HANG', operate: '取消挂起' },
  COMPANION_UN_HANG: { label: '取消挂起', key: 'COMPANION_UN_HANG', operate: '取消挂起' },
  FINISH: { label: '完工', key: 'FINISH', operate: '已完成' },
  COMPANION_FINISH: { label: '完工', key: 'COMPANION_FINISH', operate: '已完成' },
  CLOSE: { label: '关单', key: 'CLOSE', operate: '已关单' },
  CLOSED: { label: '关单', key: 'CLOSED', operate: '已关单' },
  COMMENT: { label: '评价工单', key: 'COMMENT', operate: '完成评价' },
  ACCEPTANCE: { label: '验收事件', key: 'ACCEPTANCE', operate: '同意验收' },
  AUDIT_PASS: { label: '审核通过' },
  AUDIT_FAIL: { label: '审核不通过' },
  FIRST_AUDIT_PASS: { label: '初审通过' },
  FIRST_AUDIT_FAIL: { label: '初审不通过' },
  FINAL_AUDIT_PASS: { label: '终审通过' },
  FINAL_AUDIT_FAIL: { label: '终审不通过' },
  APPROVE: { label: '审核' },
  APPROVED: { label: '已审核' },
  REJECT: { label: '退回' },
  REJECTED: { label: '被退回' },
  SNATCH: { label: '抢单' },
  UPDATE_VISIT_TIME: { label: '修改预约时间' },
  //2023-11-8新增状态
  DISCARD: { label: '作废' },
  CANCELED: { label: '取消' },
  REVOKE: { label: '退回' },
}

///**************  end  **************/


export const ProjectModules = {
  material: 'material', //材料模块
  feeChange: 'feeChange', //费用变更模块
  construction: 'construction', //施工信息
  verify: 'verify', //验收模块
  outsource: 'outsource', //外包商模块
  dispatch: 'dispatch', //这个属于 工程单派单的操作权限
  materialFeeBtn: 'materialFeeBtn' //材料变更 费用变更按钮权限
}


export const ProjectOrderStatus = {
  READY_AUDIT: {
    label: '待审核',
    key: 'READY_AUDIT',
    query: 'ready_audit',
    color: '#2D95FF',
    tagBack: '#E6F7FF',
    showOutsource: false,
    handles: [OrderOperates.audit, OrderOperates.back, OrderOperates.close,],
    modules: []
  },
  READY_OFFER: {
    //其实就是待报价 待发布
    label: '待报价',
    key: 'READY_OFFER',
    query: 'ready_offer',
    color: '#702BD0',
    tagBack: '#F8F0FF',
    showOutsource: false,
    handles: [OrderOperates.publish, OrderOperates.back],
    modules: []
  },
  READY_DISPATCH: {
    label: '待派单',
    key: 'READY_DISPATCH',
    query: 'ready_dispatch',
    color: '#26C6C6',
    tagBack: '#E7FFFB',
    showOutsource: true,
    handles: [OrderOperates.reminder, OrderOperates.back],
    modules: [ProjectModules.outsource, ProjectModules.dispatch]
  },
  READY_ACCEPT: {
    label: '待接单',
    key: 'READY_ACCEPT',
    query: 'ready_accept',
    color: '#26C6C6',
    tagBack: '#E7FFFB',
    showOutsource: true,
    handles: [OrderOperates.reminder, OrderOperates.back],
    modules: [ProjectModules.material, ProjectModules.outsource, ProjectModules.dispatch]
  },
  READY_COMPLETE: {
    label: '施工中',
    key: 'READY_COMPLETE',
    query: 'ready_complete',
    color: '#FA561C',
    tagBack: '#FFE2E8',
    showOutsource: true,
    handles: [OrderOperates.reminder, OrderOperates.back],
    modules: [
      ProjectModules.material,
      ProjectModules.feeChange,
      ProjectModules.outsource,
      ProjectModules.materialFeeBtn
    ]
  },
  READY_FIRST_AUDIT: {
    label: '待初审',
    key: 'READY_FIRST_AUDIT',
    query: 'ready_first_audit',
    color: '#F42D38',
    tagBack: '#FE8F8F',
    showOutsource: true,
    handles: [OrderOperates.inspectSelf, OrderOperates.back],
    modules: [
      ProjectModules.material,
      ProjectModules.feeChange,
      ProjectModules.outsource,
      ProjectModules.construction,
      ProjectModules.materialFeeBtn
    ]
  },
  READY_FINAL_AUDIT: {
    label: '待终审',
    key: 'READY_FINAL_AUDIT',
    query: 'ready_final_audit',
    showOutsource: true,
    color: '#F42D38',
    tagBack: '#FE8F8F',
    handles: [OrderOperates.inspect, OrderOperates.back],
    modules: [
      ProjectModules.material,
      ProjectModules.feeChange,
      ProjectModules.outsource,
      ProjectModules.construction,
      ProjectModules.verify
    ]
  },
  FINISH: {
    label: '已完工',
    key: 'FINISH',
    query: 'finish',
    color: '#51C318',
    tagBack: '#F6FFEE',
    showOutsource: true,
    handles: [OrderOperates.back],
    modules: [
      ProjectModules.material,
      ProjectModules.feeChange,
      ProjectModules.outsource,
      ProjectModules.construction,
      ProjectModules.verify
    ]
  },
  AUDIT_FAIL: {
    //这个是项目立项的审核不通过
    label: '审核不通过',
    key: 'AUDIT_FAIL',
    query: 'audit_fail',
    color: '#057877',
    showOutsource: false,
    tagBack: '#D6EEFF',
    handles: [OrderOperates.back],
    modules: []
  }
}

export const ProjectOrderStatusList = Object.keys(ProjectOrderStatus).map((key) => ProjectOrderStatus[key])

export const InspectProcessHandles = {
  reminder: { label: '催单', type: 'primary', key: 'reminder', permit: 'viewRemind' },
  inspectEstimate: { label: '评价', type: 'primary', key: 'inspectEstimate', permit: 'inspectEstimate' },
  confirmInfo: { label: '评价信息', type: 'primary', key: 'confirmInfo', permit: 'viewComment' },
  checkManifest: { label: '巡检清单', type: 'primary', key: 'checkManifest', permit: 'viewTempContent' },
  checkProcess: { label: '查看进度', type: 'primary', key: 'checkProcess', permit: 'viewProcess' },
  audit: { label: '审核', type: 'primary', key: 'audit', permit: 'audit' },
  viewAudit: { label: '审核信息', type: 'primary', key: 'viewAudit', permit: 'viewAudit' },
  childClose: { label: '关单', type: 'primary', key: 'childClose', permit: 'childClose' },
}

export const InspectChildStatus = {
  READY_DISPATCH: {
    key: 'READY_DISPATCH',
    label: '待派单',
    color: '#26C6C6',
    processHandles: [InspectProcessHandles.checkProcess, InspectProcessHandles.reminder, InspectProcessHandles.childClose]
  },
  READY_ACCEPT: {
    key: 'READY_ACCEPT',
    label: '待接单',
    color: '#26C6C6',
    processHandles: [InspectProcessHandles.checkProcess, InspectProcessHandles.reminder, InspectProcessHandles.childClose]
  },
  READY_REACH: {
    label: '待到达',
    key: 'READY_REACH',
    color: '#FA561C',
    processHandles: [InspectProcessHandles.checkProcess, InspectProcessHandles.childClose]
  },
  READY_COMPLETE: {
    label: '待完工',
    key: 'READY_COMPLETE',
    color: '#F42D38',
    processHandles: [InspectProcessHandles.checkProcess, InspectProcessHandles.childClose]
  },
  HANG: {
    label: '挂起中',
    key: 'HANG',
    query: 'hang',
    color: '#0578c4',
    tagBack: '#D6EEFF',
    handles: [OrderOperates.reminder, OrderOperates.close, OrderOperates.back]
  },
  READY_APPROVE: {
    label: '待审核',
    key: 'READY_APPROVE',
    color: '#283593',
    processHandles: [InspectProcessHandles.confirmInfo, InspectProcessHandles.checkManifest, InspectProcessHandles.checkProcess, InspectProcessHandles.inspectEstimate, InspectProcessHandles.audit, InspectProcessHandles.childClose,]
  },
  FINISH: {
    label: '已完工',
    key: 'FINISH',
    color: '#51C318',
    processHandles: [InspectProcessHandles.confirmInfo, InspectProcessHandles.checkManifest, InspectProcessHandles.checkProcess, InspectProcessHandles.inspectEstimate, InspectProcessHandles.viewAudit]
  },
  BACK: {
    label: '已退单',
    key: 'BACK',
    query: 'back',
    color: '#FA561C',
    tagBack: '#FFE2E8',
    handles: [OrderOperates.changeDispatch, OrderOperates.close, OrderOperates.back],
    showInSearch: true
  },
  CLOSE: {
    label: '已关单',
    key: 'CLOSE',
    color: '#057877',
    processHandles: [InspectProcessHandles.checkProcess]
  }
}

export const OrderMenus = {
  repair: { label: '维修单', link: '/order/repair', prop: 'repair' },
  inspect: { label: '巡检单', link: '/order/inspection', prop: 'inspection' },
  project: { label: '工程单', link: '/order/project', prop: 'project' },
  warning: { label: '故障预警', link: '/order/warning', prop: 'warning' }
}

export const ProcessManagerMenus = {
  monitor: { label: '维保', link: '/process/undertaking/monitor', prop: 'monitor' },
  project: { label: '工程', link: '/process/undertaking/project', prop: 'project' },
  program: { label: '项目', link: '/process/undertaking/program', prop: 'program' }
}

export const OrderMenuList = Object.keys(OrderMenus).map((key) => OrderMenus[key])

export const FeeChangeStatus = {
  approve: { label: '审核通过', prop: 'approve', val: 1 },
  reject: { label: '审核拒绝', prop: 'reject', val: 2 },
  readyAudit: { label: '待审核', prop: 'readyAudit', val: 0 }
}

export const FeeChangeStatusList = Object.keys(FeeChangeStatus).map((key) => FeeChangeStatus[key])

//服务能力 type list
export const DictTypeList = {
  OutsourcerScopeType: 'OutsourcerScopeType',
  ContractType: 'ContractType',
  ProjectType: 'ProjectType'
}

export const OutsourceTypes = {
  personnel: { label: '个人外包商', val: 2 },
  enterprise: { label: '企业外包商', val: 1 }
}

export const OutsourceTypeList = Object.keys(OutsourceTypes).map((key) => OutsourceTypes[key])

//外包商状态
export const OutsourceStatusList = [
  { code: 0, desc: '外包商审批状态', id: '31', pid: '0', type: 'OutsourcerCheckStatus', value: '保存 待提交审核 ' },
  { code: 1, desc: '外包商审批状态', id: '32', pid: '0', type: 'OutsourcerCheckStatus', value: '待审核' },
  { code: 2, desc: '外包商审批状态', id: '33', pid: '0', type: 'OutsourcerCheckStatus', value: '审核通过' },
  { code: 3, desc: '外包商审批状态', id: '34', pid: '0', type: 'OutsourcerCheckStatus', value: '审核未通过' }
]

///**************  完成状态  **************/
export const OrderDueStatus = {
  COMPLETE_IN_TIME: { label: '按时完成', prop: 'COMPLETE_IN_TIME' },
  UN_COMPLETE_IN_TIME: { label: '未超时未完成', prop: 'UN_COMPLETE_IN_TIME' },
  UN_COMPLETE_OVER_TIME: { label: '超时未完成', prop: 'UN_COMPLETE_OVER_TIME' },
  COMPLETE_OVER_TIME: { label: '超时完成', prop: 'COMPLETE_OVER_TIME' }
}
export const OrderDueStatusList = Object.keys(OrderDueStatus).map((key) => OrderDueStatus[key])
///**************  end  **************/


export const OrderHandleStatus = {
  BEFORE_PROCESS: { prop: 0, label: '待处理' },
  IGNORE: { prop: 1, label: '忽略' },
  REPAIR: { prop: 2, label: '报修', isDetail: true },
  DISPATCH: { prop: 3, label: '派单中', isDetail: true },
  FALSE_POSITIVE: { prop: 4, label: '误报' },
  END: { prop: 5, label: '完结', isDetail: true }
}

export const OrderHandleStatusList = Object.values(OrderHandleStatus)


export const VerifyTypes = { login: 'LOGIN', updatePassword: 'UPDATE_PASSWORD', register: 'REGISTER' }

export const FileTypes = {
  image: { label: '图片', accept: '.png, .jpg', des: '.png、.jpg', prop: 'image' },
  word: { label: 'word', accept: '.doc, .docx', des: '.doc、.docx', prop: 'word' },
  excel: { label: '表格', accept: '.xlsx, .xls', des: '.xlsx、.xls', prop: 'excel' },
  pdf: { label: 'pdf', accept: '.pdf', des: '.pdf', prop: 'pdf' }
}

export const ProcessProjectNodes = {
  PROJECT_INIT: { title: '项目立项', prop: 'approvalList', key: 'PROJECT_INIT', paramsKey: 'init' },
  PROJECT_OFFER_PRICE: { title: '项目报价', prop: 'offerList', key: 'PROJECT_OFFER_PRICE', paramsKey: 'offerPrice' },
  PROJECT_CONSTRUCT: {
    title: '项目实施',
    prop: 'implementList',
    key: 'PROJECT_CONSTRUCT',
    restrictImage: true,
    paramsKey: 'construct'
  },
  PROJECT_VALIDATE: {
    title: '项目验收',
    prop: 'inspectList',
    key: 'PROJECT_VALIDATE',
    restrictImage: true,
    paramsKey: 'validate'
  },
  PROJECT_RECTIFY: {
    title: '退回整改',
    prop: 'rectify',
    key: 'PROJECT_RECTIFY',
    restrictImage: true,
    paramsKey: 'rectify'
  }
}


export const ProcessProjectNodeList = Object.keys(ProcessProjectNodes).map((key) => ProcessProjectNodes[key])



///**************  工程项目详情  **************/
export const EngineeringModules = []

export const EngineeringParentStatus = {
  UNDER_CONSTRUCTION: {
    key: 'UNDER_CONSTRUCTION',
    label: '施工中',
    color: '#8FB800',
    tagBack: '#F8FAE9',
    handles: [OrderOperates.back]
  },
  FINISH: {
    key: 'FINISH',
    label: '已完工',
    color: '#0EACA1',
    tagBack: '#E7F5F4',
    handles: [OrderOperates.back]
  },
  CLOSE: {
    key: 'CLOSE',
    label: '已关单',
    color: '#333333',
    tagBack: '#EDEDED',
    handles: [OrderOperates.back]
  },
  READY_APPROVE: {
    label: '待审核',
    key: 'READY_APPROVE',
    query: 'ready_approve',
    color: '#00B2EC',
    tagBack: '#EBFAFF',
    handles: [OrderOperates.approve, OrderOperates.back, OrderOperates.close]
  }
}
export const EngineeringParentStatusList = Object.values(EngineeringParentStatus)
///**************  end  **************/



// WEBPACK FOOTER //
// ./src/config/enums.js